import { Tabs } from 'antd'
import { useEffect, useState } from 'react'

import { BitazzaText, Spinner } from '../../../components'
import { Top100 } from './'
import { LeaderTraderModal } from './HeaderTab/LeaderTraderModal'
import { useMediaQuery } from 'react-responsive'
import { IMGs } from '../../../assets/img'

interface Props {
    data?: LeaderBoardData[] | []
    user?: usersDataType

    onSearchUserTag: (value: string) => void
    searchResults?: LeaderBoardData[] | []
    status: string
    onTimeFrameChangeHandler: (type: string) => void
    selectedTime: string
    hallOfFame?: hallOfFame[][]
    OnSelectedRankTab: (tab: string) => void
    selectedRankTab: string
    isTabLoading: (value: boolean) => void
}

export const LeaderBoardTabs: React.FC<Props> = ({
    data,
    user,
    onSearchUserTag,
    searchResults,
    onTimeFrameChangeHandler,
    status,
    selectedTime,
    hallOfFame,
    OnSelectedRankTab,
    selectedRankTab,
    isTabLoading,
}) => {
    const [isLeaderModalOpen, setIsLeaderModalOpen] = useState(false)
    const isDesktop = useMediaQuery({ minWidth: 768 })
    const [isLoading, setIsLoading] = useState(true)

    const [isImageLoaded, setIsImageLoaded] = useState(true)
    const [backgroundImg, setBackgroundImg] = useState({})

    useEffect(() => {
        const image = new Image()
        const imageUrl = IMGs.Glowing

        image.src = imageUrl
        image.onload = () => {
            setIsImageLoaded(false)
            setBackgroundImg(image.src)
        }
    }, [])

    useEffect(() => {
        isTabLoading(isLoading || isImageLoaded)
    }, [isLoading, isImageLoaded])

    const items = [
        {
            label: (
                <BitazzaText
                    textAlign="center"
                    content="All Time"
                    format={isDesktop ? 't24' : 't16'}
                    noWrap
                    color="#b7b7b7"
                    bold
                    hover
                />
            ),
            key: 'all-time',
            children: (
                <>
                    <Top100
                        setIsLeaderModalOpen={(value) =>
                            setIsLeaderModalOpen(value)
                        }
                        notTop3={
                            selectedRankTab === 'myRanking' ||
                            selectedRankTab === 'hallOfFame'
                        }
                        rank={data}
                        user={user}
                        status={status}
                        selectedRankTab={selectedRankTab}
                        selectedTime={selectedTime}
                        OnSelectedRankTab={OnSelectedRankTab}
                        onSearchUserTag={onSearchUserTag}
                        searchResults={searchResults}
                        isTop100Loading={(value) => setIsLoading(value)}
                    />
                </>
            ),
        },
        {
            label: (
                <BitazzaText
                    textAlign="center"
                    content="Monthly"
                    format={isDesktop ? 't24' : 't16'}
                    noWrap
                    color="#b7b7b7"
                    bold
                    hover
                />
            ),
            key: 'monthly',
            children: (
                <>
                    <Top100
                        setIsLeaderModalOpen={(value) =>
                            setIsLeaderModalOpen(value)
                        }
                        status={status}
                        selectedRankTab={selectedRankTab}
                        rank={data}
                        user={user}
                        notTop3={
                            selectedRankTab === 'myRanking' ||
                            selectedRankTab === 'hallOfFame'
                        }
                        onSearchUserTag={onSearchUserTag}
                        searchResults={searchResults}
                        selectedTime={selectedTime}
                        OnSelectedRankTab={OnSelectedRankTab}
                        hallOfFame={hallOfFame}
                        isTop100Loading={(value) => setIsLoading(value)}
                    />
                </>
            ),
        },
    ]

    const tabHandler = (value: string) => {
        onTimeFrameChangeHandler(value)
    }

    // useEffect(() => {
    //     console.log("items", items)
    // }, [items])

    return (
        <>
            <LeaderTraderModal
                isOpen={isLeaderModalOpen}
                onCancelModal={() => setIsLeaderModalOpen(false)}
            />

            <Tabs
                tabBarStyle={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                }}
                tabBarExtraContent={
                    <>
                        {' '}
                        {selectedTime === 'monthly' && isDesktop ? (
                            <BitazzaText
                                textAlign="center"
                                content="Monthly rankings reset every end of the month. "
                                color="rgba(255, 255, 255, 0.75)"
                            />
                        ) : null}
                    </>
                }
                destroyInactiveTabPane
                style={{
                    position: !isDesktop ? 'fixed' : 'inherit',
                    top: !isDesktop
                        ? '0px'
                        : selectedTime === 'monthly'
                        ? '80px'
                        : '60px',
                    width: '100%',
                    padding: '0px 16px',
                    // marginRight: '24px',
                    backgroundImage: !(
                        selectedRankTab === 'myRanking' ||
                        selectedRankTab === 'hallOfFame'
                    )
                        ? `url(${backgroundImg})`
                        : 'unset',
                    backgroundSize: '1600px 600px',
                    backgroundPosition: isDesktop ? 'top' : 'top -50px center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#090916',
                }}
                items={items}
                onChange={tabHandler}
            />
        </>
    )
}
